// extracted by mini-css-extract-plugin
export default {"container":"Separator_container__3fgSs","text":"Separator_text__9BegK","line":"Separator_line__VZZvj"};